export const NAMESPACE = 'timestamps';

export const ONE_WEEK = 1000 * 60 * 60 * 24 * 7;
export const FOUR_WEEKS = 4 * ONE_WEEK;

export const LOCAL_STORAGE_FULL_ERROR_CODE = 22;
export const LOCAL_STORAGE_FULL_FF_ERROR_CODE = 1014;
